import { FieldProps, FormikErrors, getIn } from 'formik';
import React from 'react';
import ReactQuill from 'react-quill';

import { InputState } from './common';
import { AiButton, buildField } from '../../../components/AiButton/AiButton';
import styles from './wysiwygField.scss';

interface Props extends FieldProps {
  placeholder: string;
  showAiButton: boolean;
  formats?: string[];
  modules?: [string[] | [{ align: string[] }]];
  bounds?: string | HTMLElement;
}

const BLANK_TEXT = '<p><br></p>';
const DEFAULT_FORMATS = ['bold', 'italic', 'align'];
const DEFAULT_MODULES = [['bold', 'italic'], [{ align: [] }]];

export const WysiwygField: React.FC<Props> = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched, values },
  placeholder,
  showAiButton = false,
  modules,
  formats,
  bounds,
}) => {
  let subText: string | FormikErrors<any> | undefined;
  const fieldTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  const [isFocused, setIsFocused] = React.useState<boolean>(false);

  // @ts-ignore
  const onChange = (val): void => {
    const value = val === BLANK_TEXT ? '' : val;
    setFieldValue(field.name, value);
  };

  const onBlur = (): void => {
    setFieldTouched(field.name);
    setIsFocused(false);
  };

  let state: InputState = 'neutral';
  if (fieldTouched && error) {
    subText = error;
    state = 'invalid';
  }

  return (
    <div className={`${styles.wysiwyg} ${state && styles[state]}`}>
      <ReactQuill
        value={field.value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        placeholder={placeholder}
        onBlur={() => {
          onBlur();
        }}
        modules={{ toolbar: modules || DEFAULT_MODULES }}
        formats={formats || DEFAULT_FORMATS}
        bounds={bounds}
      ></ReactQuill>
      {showAiButton && (
        <AiButton
          className={styles.aiButton}
          field={buildField(field, setFieldValue, values)}
          isParentFocused={isFocused}
        />
      )}
      {subText && <div className={styles.subText}>{subText}</div>}
    </div>
  );
};

export default WysiwygField;
